import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "users-top-section" }
const _hoisted_2 = { class: "users-total-above-list" }
const _hoisted_3 = { class: "users-total-label" }
const _hoisted_4 = { class: "users-total-actions" }
const _hoisted_5 = {
  key: 0,
  class: "users-loading"
}
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = { class: "user-email" }
const _hoisted_8 = { class: "user-role-badges" }
const _hoisted_9 = {
  key: 0,
  class: "user-release-badges"
}
const _hoisted_10 = {
  key: 1,
  class: "users-empty"
}
const _hoisted_11 = {
  key: 0,
  class: "users-pagination"
}
const _hoisted_12 = { class: "users-pagination-label" }
const _hoisted_13 = { class: "create-user-form" }
const _hoisted_14 = { class: "create-user-grid" }
const _hoisted_15 = { class: "create-user-actions" }
const _hoisted_16 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_17 = { class: "chip-area" }
const _hoisted_18 = {
  key: 0,
  class: "add-access-placeholder"
}
const _hoisted_19 = { class: "chip-area" }
const _hoisted_20 = {
  key: 0,
  class: "add-access-placeholder"
}
const _hoisted_21 = { class: "chip-area" }
const _hoisted_22 = {
  key: 0,
  class: "add-access-placeholder"
}
const _hoisted_23 = { class: "user-groups-btn-container add-access-actions" }
const _hoisted_24 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_25 = { class: "user-groups-btn-container" }
const _hoisted_26 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_27 = { class: "user-groups-btn-container" }
const _hoisted_28 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_29 = { class: "user-groups-btn-container" }
const _hoisted_30 = { class: "users-activity-body ion-padding" }
const _hoisted_31 = { class: "activity-summary" }
const _hoisted_32 = { class: "activity-summary-card" }
const _hoisted_33 = { class: "activity-summary-card" }
const _hoisted_34 = { class: "activity-chart-block" }
const _hoisted_35 = { class: "activity-chart-header" }
const _hoisted_36 = {
  key: 0,
  class: "activity-loading"
}
const _hoisted_37 = {
  key: 1,
  class: "activity-loading"
}
const _hoisted_38 = {
  key: 2,
  class: "activity-chart"
}
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "activity-chart-count" }
const _hoisted_41 = { class: "activity-chart-date" }
const _hoisted_42 = { class: "activity-sessions-block" }
const _hoisted_43 = { class: "activity-chart-header" }
const _hoisted_44 = {
  key: 0,
  class: "activity-loading"
}
const _hoisted_45 = {
  key: 1,
  class: "activity-loading"
}
const _hoisted_46 = {
  key: 2,
  class: "activity-sessions-list"
}
const _hoisted_47 = { class: "activity-session-top" }
const _hoisted_48 = { class: "activity-session-meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Пользователи",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background users-page-mobile' : 'liga-web-background']),
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_searchbar, {
              class: "user-search",
              placeholder: "Поиск",
              inputmode: "text",
              type: "text",
              onIonInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSearchChange($event))),
              debounce: 500
            }),
            _createVNode(_component_ion_item, {
              class: "filter-field-clear-button",
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  class: "filter-field",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      label: "Группы прав",
                      modelValue: _ctx.authoritiesFilter,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.authoritiesFilter) = $event)),
                      multiple: true,
                      placeholder: "Не выбрано",
                      "cancel-text": "Отмена",
                      mode: "ios",
                      "interface-options": _ctx.customSelectOptions
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (authority) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: authority.name,
                            value: authority.name
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(authority.description), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "interface-options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_icon, {
                  slot: "end",
                  icon: _ctx.closeOutline,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearFilter('authorities')))
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, {
              class: "filter-field-clear-button",
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  class: "filter-field",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      label: "Допуск к отдельным релизам",
                      value: _ctx.releasesFilter,
                      multiple: true,
                      placeholder: "Не выбрано",
                      "cancel-text": "Отмена",
                      mode: "ios",
                      "interface-options": _ctx.customSelectOptions,
                      onIonChange: _ctx.onReleasesFilterChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allReleases, (r) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: r.id,
                            value: r.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(r.program ? r.program.programName : '') + " " + _toDisplayString(r.releaseName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "interface-options", "onIonChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_icon, {
                  slot: "end",
                  icon: _ctx.closeOutline,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearFilter('releases')))
                }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, "Всего: " + _toDisplayString(_ctx.totalItems), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ion_button, {
                fill: "clear",
                size: "small",
                class: "users-refresh-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestUsers())),
                title: "Обновить список"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.refreshOutline }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                size: "small",
                fill: "solid",
                shape: "round",
                class: "users-panel-btn users-panel-btn-cache",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refreshRolesCache())),
                title: "Обновить кеш ролей у всех пользователей"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.refreshOutline
                  }, null, 8, ["icon"]),
                  _cache[47] || (_cache[47] = _createTextVNode(" Кеш ролей ", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                size: "small",
                fill: "solid",
                shape: "round",
                class: "users-panel-btn users-panel-btn-create",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openCreateUserModal())),
                title: "Создать учетную запись"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.personAddOutline
                  }, null, 8, ["icon"]),
                  _cache[48] || (_cache[48] = _createTextVNode(" Создать ", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                size: "small",
                fill: "outline",
                shape: "round",
                class: "users-panel-btn users-panel-btn-activity",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openActivityModal())),
                title: "Просмотр активности"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.statsChartOutline
                  }, null, 8, ["icon"]),
                  _cache[49] || (_cache[49] = _createTextVNode(" Активность ", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                size: "small",
                fill: "outline",
                shape: "round",
                class: "users-panel-btn users-panel-btn-groups",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openUserGroupsSelector())),
                title: "Группы прав"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.keyOutline
                  }, null, 8, ["icon"]),
                  _cache[50] || (_cache[50] = _createTextVNode(" Группы ", -1))
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_ion_content, {
            class: "bg-transparent users-list-scroll",
            onIonScroll: _ctx.onContentScroll
          }, {
            default: _withCtx(() => [
              (_ctx.usersLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Загрузка..."))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_ion_list, {
                class: "bg-transparent",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: user.id,
                      lines: "none",
                      class: "user-item",
                      onClick: ($event: any) => (_ctx.openUserSettings(user))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-margin-start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(user.lastName) + " " + _toDisplayString(user.firstName), 1),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(user.email), 1),
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUserAuthorityBadges(user), (auth) => {
                                return (_openBlock(), _createBlock(_component_ion_badge, {
                                  key: auth.name,
                                  class: "role-badge",
                                  color: "orange",
                                  title: auth.description
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(auth.shortLabel), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["title"]))
                              }), 128))
                            ]),
                            (_ctx.getUserReleaseBadges(user).length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUserReleaseBadges(user), (rel) => {
                                    return (_openBlock(), _createBlock(_component_ion_badge, {
                                      key: rel.id,
                                      class: "release-badge",
                                      color: "orange",
                                      title: rel.label
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rel.shortLabel), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _withDirectives(_createVNode(_component_ion_button, {
                          onClick: ($event: any) => {_ctx.setActive(user, false); $event.stopPropagation()},
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "button-label" }, {
                              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                _createTextVNode("Активный", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_icon, {
                              slot: "end",
                              icon: _ctx.checkmarkOutline,
                              class: "button-icon"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"]), [
                          [_vShow, user.activated]
                        ]),
                        _withDirectives(_createVNode(_component_ion_button, {
                          onClick: ($event: any) => {_ctx.setActive(user, true); $event.stopPropagation()},
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "button-label" }, {
                              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                _createTextVNode("Неактивный", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.closeOutline,
                              class: "button-icon"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"]), [
                          [_vShow, !user.activated]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128)),
                  _createVNode(_component_ion_item, {
                    class: "fake-footer bg-transparent",
                    lines: "none"
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, !_ctx.usersLoading && _ctx.totalItems > 0]
              ]),
              (!_ctx.usersLoading && _ctx.totalItems === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Пользователи не найдены."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onIonScroll"]),
          (_ctx.totalPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  size: "small",
                  disabled: _ctx.currentPage <= 0 || _ctx.usersLoading,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createTextVNode(" Назад ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("span", _hoisted_12, " Страница " + _toDisplayString(_ctx.currentPage + 1) + " из " + _toDisplayString(_ctx.totalPages), 1),
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  size: "small",
                  disabled: _ctx.currentPage >= _ctx.totalPages - 1 || _ctx.usersLoading,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                }, {
                  default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                    _createTextVNode(" Вперёд ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showUserSettings,
            breakpoints: [0, 1],
            initialBreakpoint: 1,
            class: "user-settings-modal",
            onIonModalDidDismiss: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showUserSettings = false)),
            onDidDissmiss: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeUserSettings()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "bg-transparent modal-background" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, { class: "user-settings-header" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, { class: "user-settings-header-title" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.selectedUser[0].firstName) + " " + _toDisplayString(_ctx.selectedUser[0].lastName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeUserSettings())),
                                slot: "end",
                                class: "user-settings-header-button"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.closeOutline,
                                    slot: "icon-only"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { class: "common-field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { slot: "start" }, {
                        default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                          _createTextVNode("Логин", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedUser[0].login), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { class: "common-field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { slot: "start" }, {
                        default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                          _createTextVNode("E-Mail", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedUser[0].email), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_accordion_group, { class: "bg-transparent" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_accordion, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "role-header"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                  _createTextVNode("Группы прав", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent role-list",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, { class: "role-item add-role-button" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Добавить",
                                    multiple: true,
                                    "cancel-text": "Отмена",
                                    mode: "ios",
                                    onIonChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onCommonAuthoritiesChanged($event))),
                                    "interface-options": _ctx.customSelectOptions
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commonAuthorities, (authority) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: authority.name,
                                          value: authority.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.commonAuthorities.length > 0]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUserAuthorities, (authority) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  key: authority.name
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_ion_item, { class: "role-item" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1536), [
                                      [_vShow, authority.groupId == 1]
                                    ]),
                                    _createVNode(_component_ion_item_options, { side: "end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.removeAuthority(authority))
                                        }, {
                                          default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                            _createTextVNode("Удалить", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_accordion, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "role-header"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                  _createTextVNode("Допуск к программам", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent role-list",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, { class: "role-item add-role-button" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Добавить",
                                    multiple: true,
                                    "cancel-text": "Отмена",
                                    mode: "ios",
                                    onIonChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onProgramAuthoritiesChanged($event))),
                                    "interface-options": _ctx.customSelectOptions
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programAuthorities, (authority) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: authority.name,
                                          value: authority.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.programAuthorities.length > 0]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUserAuthorities, (authority) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  key: authority.name
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_ion_item, { class: "role-item" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1536), [
                                      [_vShow, authority.groupId == 2]
                                    ]),
                                    _createVNode(_component_ion_item_options, { side: "end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.removeAuthority(authority))
                                        }, {
                                          default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                            _createTextVNode("Удалить", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_accordion, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "role-header"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                  _createTextVNode("Допуск к отдельным релизам", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent role-list",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, { class: "role-item add-role-button" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Добавить",
                                    multiple: true,
                                    "cancel-text": "Отмена",
                                    mode: "ios",
                                    onIonChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onReleaseAuthoritiesChanged($event))),
                                    "interface-options": _ctx.customSelectOptions
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseAuthorities, (release) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: release.id,
                                          value: release
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.releaseAuthorities.length > 0]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUserReleases, (release) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  key: release.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, { class: "role-item" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_item_options, { side: "end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.removeReleaseAuthority(release))
                                        }, {
                                          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                            _createTextVNode("Удалить", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showCreateUser,
            class: "create-user-modal",
            onDidDismiss: _cache[25] || (_cache[25] = ($event: any) => (_ctx.closeCreateUserModal()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "bg-transparent modal-background" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, { class: "user-settings-header" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, { class: "user-settings-header-title" }, {
                            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                              _createTextVNode("Создать учетную запись", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeCreateUserModal())),
                                slot: "end",
                                class: "user-settings-header-button"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.closeOutline,
                                    slot: "icon-only"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[65] || (_cache[65] = _createElementVNode("p", { class: "create-user-hint" }, " Пароль будет задан автоматически: по текущей backend-логике это email пользователя в нижнем регистре. ", -1)),
                    _createVNode(_component_ion_item, { class: "create-user-field" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Логин",
                          "label-placement": "stacked",
                          modelValue: _ctx.newUser.login,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newUser.login) = $event)),
                          placeholder: "ivanov"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "create-user-field" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "E-Mail",
                          "label-placement": "stacked",
                          type: "email",
                          modelValue: _ctx.newUser.email,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newUser.email) = $event)),
                          placeholder: "user@example.com"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ion_item, { class: "create-user-field" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            label: "Имя",
                            "label-placement": "stacked",
                            modelValue: _ctx.newUser.firstName,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newUser.firstName) = $event)),
                            placeholder: "Иван"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { class: "create-user-field" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            label: "Фамилия",
                            "label-placement": "stacked",
                            modelValue: _ctx.newUser.lastName,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newUser.lastName) = $event)),
                            placeholder: "Иванов"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_ion_item, { class: "create-user-field" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          label: "Группы прав",
                          "label-placement": "stacked",
                          modelValue: _ctx.newUser.authorities,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newUser.authorities) = $event)),
                          multiple: true,
                          "cancel-text": "Отмена",
                          mode: "ios",
                          "interface-options": _ctx.customSelectOptions,
                          placeholder: "Выберите роли"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creatableAuthorities, (authority) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: authority.name,
                                value: authority.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(authority.description || authority.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "interface-options"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        class: "create-user-save-btn",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.createUser())),
                        disabled: _ctx.creatingUser || !_ctx.canCreateUser
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.creatingUser ? 'Создание…' : 'Создать учетную запись'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        fill: "outline",
                        class: "create-user-cancel-btn",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeCreateUserModal()))
                      }, {
                        default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "can-dismiss": true,
            onDidDismiss: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showUserGroups = false)),
            "is-open": _ctx.showUserGroups,
            class: "user-groups-modal user-groups-modal-add-access"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_ion_card, { class: "add-access-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { class: "add-access-header" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, { class: "add-access-title" }, {
                          default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                            _createTextVNode("Добавление доступа", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_subtitle, { class: "add-access-subtitle" }, {
                          default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                            _createTextVNode("Выберите группы прав, релизы и пользователей", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, { class: "add-access-content" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "user-groups-select-area add-access-select-tile",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showAuthoritiesSelector = true))
                        }, [
                          _cache[68] || (_cache[68] = _createElementVNode("span", { class: "add-access-tile-label" }, "Группы прав", -1)),
                          _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAuthorities, (authority) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                                key: authority.name,
                                class: "add-access-chip",
                                color: "orange",
                                mode: "ios",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.removeSelectedAuthorities(authority, _ctx.selectedAuthorities, 'name')), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(authority.description), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_vShow, _ctx.selectedAuthorities.length > 0]
                              ])
                            }), 128)),
                            (_ctx.selectedAuthorities.length === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Нажмите для выбора"))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "user-groups-select-area add-access-select-tile",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showReleasesSelector = true))
                        }, [
                          _cache[69] || (_cache[69] = _createElementVNode("span", { class: "add-access-tile-label" }, "Релизы", -1)),
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedReleases, (release) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                                key: release.id,
                                class: "add-access-chip",
                                color: "orange",
                                mode: "ios",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.removeSelectedReleases(release, _ctx.selectedReleases, 'id')), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_vShow, _ctx.selectedReleases.length > 0]
                              ])
                            }), 128)),
                            (_ctx.selectedReleases.length === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Нажмите для выбора"))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "user-groups-select-area add-access-select-tile",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showUsersSelector = true))
                        }, [
                          _cache[70] || (_cache[70] = _createElementVNode("span", { class: "add-access-tile-label" }, "Пользователи", -1)),
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (user) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                                key: user.id,
                                class: "add-access-chip",
                                color: "orange",
                                mode: "ios",
                                onClick: _withModifiers(($event: any) => (_ctx.removeSelectedUsers(user, _ctx.selectedUsers, 'id')), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(user.lastName) + " " + _toDisplayString(user.firstName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_vShow, _ctx.selectedUsers.length > 0]
                              ])
                            }), 128)),
                            (_ctx.selectedUsers.length === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Нажмите для выбора"))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        shape: "round",
                        class: "add-access-btn-cancel",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.dismissUserGroups()))
                      }, {
                        default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "solid",
                        shape: "round",
                        class: "add-access-btn-save",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.acceptUserGroups()))
                      }, {
                        default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                          _createTextVNode(" Сохранить ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showAuthoritiesSelector,
            class: "user-groups-modal",
            onIonModalDidDismiss: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showAuthoritiesSelector = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                            _createTextVNode("Выбор группы прав", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_searchbar, {
                      class: "user-search",
                      placeholder: "Поиск",
                      inputmode: "text",
                      type: "text",
                      onIonInput: _cache[32] || (_cache[32] = ($event: any) => (_ctx.addAuthoritiesFilter($event))),
                      debounce: 500
                    }),
                    _createVNode(_component_ion_card_content, { class: "list-selector-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (authority) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                class: _normalizeClass([
                  _ctx.isSelectedByKey(authority, _ctx.selectedAuthorities, 'name')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]),
                                onClick: ($event: any) => (
  _ctx.isSelectedByKey(authority, _ctx.selectedAuthorities, 'name')
    ? _ctx.removeSelectedAuthorities(
      authority,
      _ctx.selectedAuthorities,
      'name'
    )
    : _ctx.addSelection(authority, _ctx.selectedAuthorities)
  ),
                                key: authority.name,
                                value: authority.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(authority.description), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick", "value"])), [
                                [_vShow, _ctx.filterAuthorities(authority)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.approveAuthoritiesSelector())),
                        class: "user-groups-accept-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить " + _toDisplayString(_ctx.selectedAuthorities.length > 0
                  ? `(${_ctx.selectedAuthorities.length})`
                  : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.dismissAuthoritiesSelector()))
                      }, {
                        default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showReleasesSelector,
            class: "user-groups-modal",
            onIonModalDidDismiss: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showReleasesSelector = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                            _createTextVNode("Выбор релиза", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_searchbar, {
                      class: "user-search",
                      placeholder: "Поиск",
                      inputmode: "text",
                      type: "text",
                      onIonChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.addReleasesFilter($event))),
                      debounce: 500
                    }),
                    _createVNode(_component_ion_card_content, { class: "list-selector-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseAuthorities, (release) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                class: _normalizeClass([
                  _ctx.isSelectedByKey(release, _ctx.selectedReleases, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]),
                                onClick: ($event: any) => (
  _ctx.isSelectedByKey(release, _ctx.selectedReleases, 'id')
    ? _ctx.removeSelectedReleases(release, _ctx.selectedReleases, 'id')
    : _ctx.addSelection(release, _ctx.selectedReleases)
  ),
                                key: release.id,
                                value: release
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick", "value"])), [
                                [_vShow, _ctx.filterReleases(release)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.approveReleasesSelector())),
                        class: "user-groups-accept-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить " + _toDisplayString(_ctx.selectedReleases.length > 0
                  ? `(${_ctx.selectedReleases.length})`
                  : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.dismissReleasesSelector()))
                      }, {
                        default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showUsersSelector,
            class: "user-groups-modal",
            onIonModalDidDismiss: _cache[43] || (_cache[43] = ($event: any) => (_ctx.showUsersSelector = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                            _createTextVNode("Выбор пользователей", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_searchbar, {
                      class: "user-search",
                      placeholder: "Поиск",
                      inputmode: "text",
                      type: "text",
                      onIonInput: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onSearchChange($event))),
                      debounce: 500
                    }),
                    _createVNode(_component_ion_card_content, { class: "list-selector-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                class: _normalizeClass([
                  _ctx.isSelectedByKey(user, _ctx.selectedUsers, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]),
                                onClick: ($event: any) => (
  _ctx.isSelectedByKey(user, _ctx.selectedUsers, 'id')
    ? _ctx.removeSelectedUsers(user, _ctx.selectedUsers, 'id')
    : _ctx.addSelection(user, _ctx.selectedUsers)
  ),
                                key: user.id,
                                value: user
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(user.lastName) + " " + _toDisplayString(user.firstName), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick", "value"])), [
                                [_vShow, _ctx.filterUsers(user)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.approveUsersSelector())),
                        class: "user-groups-accept-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить " + _toDisplayString(_ctx.selectedUsers.length > 0 ? `(${_ctx.selectedUsers.length})` : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.dismissUsersSelector()))
                      }, {
                        default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showActivityModal,
            class: "users-activity-modal",
            onDidDismiss: _cache[46] || (_cache[46] = ($event: any) => (_ctx.closeActivityModal()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "bg-transparent modal-background users-activity-content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, { class: "user-settings-header" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, { class: "user-settings-header-title" }, {
                            default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                              _createTextVNode("Активность пользователей", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.closeActivityModal())),
                                class: "user-settings-header-button"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.closeOutline,
                                    slot: "icon-only"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[80] || (_cache[80] = _createElementVNode("span", null, "Активных сейчас", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.activitySessions.length), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _cache[81] || (_cache[81] = _createElementVNode("span", null, "Уникальных пользователей", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.activityUniqueUsers), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[82] || (_cache[82] = _createElementVNode("h3", null, "Активность по дням", -1)),
                        _createElementVNode("span", null, "за " + _toDisplayString(_ctx.activityDays) + " дней", 1)
                      ]),
                      (_ctx.activityLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Загрузка..."))
                        : (!_ctx.activityDailyStats.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Нет данных за выбранный период."))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityDailyStats, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.date,
                                  class: "activity-chart-bar-wrap"
                                }, [
                                  _createElementVNode("div", {
                                    class: "activity-chart-bar",
                                    style: _normalizeStyle({ height: `${Math.max(8, (item.count / _ctx.activityChartMax) * 100)}%` }),
                                    title: `${_ctx.formatActivityDate(item.date)}: ${item.count} пользователей`
                                  }, null, 12, _hoisted_39),
                                  _createElementVNode("span", _hoisted_40, _toDisplayString(item.count), 1),
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.formatActivityShortDate(item.date)), 1)
                                ]))
                              }), 128))
                            ]))
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _cache[83] || (_cache[83] = _createElementVNode("h3", null, "Текущие активные сессии", -1)),
                        _createVNode(_component_ion_button, {
                          fill: "clear",
                          size: "small",
                          disabled: _ctx.activityLoading,
                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.loadActivityData()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.refreshOutline }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      (_ctx.activityLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Загрузка..."))
                        : (!_ctx.activitySessions.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, "Нет активных сессий."))
                          : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activitySessions, (session) => {
                                return (_openBlock(), _createElementBlock("article", {
                                  key: session.id,
                                  class: "activity-session-card"
                                }, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatSessionUser(session)), 1),
                                    _createElementVNode("span", null, _toDisplayString(session.userEmail || '—'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("span", null, _toDisplayString(session.deviceName || 'Устройство'), 1),
                                    _createElementVNode("span", null, "Создана: " + _toDisplayString(_ctx.formatSessionDateTime(session.createdAt)), 1),
                                    _createElementVNode("span", null, "Последняя активность: " + _toDisplayString(_ctx.formatSessionDateTime(session.lastUsedAt || session.createdAt)), 1)
                                  ])
                                ]))
                              }), 128))
                            ]))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}